<div class="container mt-4">
  <div class="mb-4">
    <fgbcl-ticket-transfer-status />
  </div>
  <fgbcl-recipient-form [action]="tickerTransferAction" (onCancel)="goBack()"></fgbcl-recipient-form>
</div>
